import { Link } from "react-router-dom";
import type { SiteSettings } from "@/lib/types";

function SmartLink({ href, children }: { href: string; children: React.ReactNode }) {
  const isExternal = /^https?:\/\//.test(href) || href.startsWith("mailto:") || href.startsWith("tel:");
  if (isExternal || href.startsWith("#")) return <a href={href}>{children}</a>;
  return <Link to={href}>{children}</Link>;
}

export default function Footer({ settings }: { settings: SiteSettings }) {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div style={{ color: "var(--white)", fontFamily: "Fraunces, serif", fontSize: 22, fontWeight: 500, marginBottom: 12 }}>
            {settings.siteName}
          </div>
          <p className="footer-tagline">{settings.footer.tagline}</p>
        </div>
        {settings.footer.columns.map((col) => (
          <div className="footer-col" key={col.heading}>
            <h4>{col.heading}</h4>
            <ul>
              {col.links.map((l) => (
                <li key={l.label}>
                  <SmartLink href={l.href}>{l.label}</SmartLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="footer-bottom">
        {settings.footer.bottom.map((line, i) => (
          <div key={i}>{line}</div>
        ))}
      </div>
    </footer>
  );
}
